<template>
  <DataFetcher v-slot:default="{ items }" endpoint="/users">
    <v-autocomplete 
      v-model="brandProxy" 
      :items="filterBrands(items)" 
      :label="$t('Calendar.Label.brand')" 
      item-text="brand" 
      item-value="id"
      color="primary" 
      return-object 
      hide-details
      prepend-inner-icon="store"
    >
      <template v-slot:item="data">
        <v-list-item-avatar tile>
          <img v-if="data.item.picture" :src="getPicturePath(data.item.picture)">
          <v-icon v-else>store</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.brand"></v-list-item-title>
          <v-list-item-subtitle :class="{'success--text': data.item.isActive, 'error--text': !data.item.isActive}">
            {{data.item.isActive ? 'Active' : 'Inactive'}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </DataFetcher>
</template>

<script>
import DataFetcher from '@/components/Utils/DataFetcher'
import FilesPathHelpersMixin from '@/mixins/FilesPathHelpersMixin'
export default {
  name: 'BrandSelector',
  components: {DataFetcher},
  mixins: [FilesPathHelpersMixin],
  props: {
    value: {required: true}, // allow null
    belongsToThisMall: {type: Object, required: false}
  },
  computed: {
    brandProxy: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    filterBrands (items) {
      return items
        .filter(user => user.brand && (!this.belongsToThisMall || user.mall.id === this.belongsToThisMall.id))
        .sort((a, b) => a.brand < b.brand ? -1 : 0)
        .sort((a, b) => a.isActive && !b.isActive ? -1 : 1)
    }
  }
}
</script>